<template></template>

<script>
  import 'jquery-validation'
  
  export default {
    name: 'RegisterLanguage',
    mounted() {
      /**
       * Init JQuery validation
       */
      $(() => {
        $(document).ready(function() {
          $('.form').validate({
            ignore: [],
            highlight: function(element, errorClass, validClass) {
              $(element).addClass('is-invalid')
            },
            unhighlight: function(element, errorClass, validClass) {
              $(element).removeClass('is-invalid')
            },
            errorPlacement: function(label, element) {
              if(element.hasClass('select2-input')) {
                label.insertAfter(element.siblings('span.select2'))
              } else if(element.is(':radio')) {
                label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
              }
              else {
                label.insertAfter(element)
              }
              
              label.addClass('invalid-feedback')
            },
            rules: {
              language_id: {
                required: true,
              },
              another_language: {
                required: function () {
                  return $('select[name="language_id"] option:selected').text() === 'Otro'
                },
              },
            },
            messages: {
              language_id: {
                required: 'Este campo es requerido.',
              },
              another_language: {
                required: 'Este campo es requerido.',
              },
            },
            submitHandler(form) {
              form.submit()
            },
          })
        })

        /**
         * Range sliders
         */
        $('.form-control-range').on('input', function(){
            $(this).siblings('span.slider-percent').html(this.value + '%')
        })

        /**
         * Show and hide Another language input
         */
        collapseLanguageInput($('select[name="language_id"] option:selected').text())

        $('select[name="language_id"]').on('change', function() {
          collapseLanguageInput($('select[name="language_id"] option:selected').text())
        })

        function collapseLanguageInput(value) {
          if (value === 'Otro') {
            $('#another-language-input').removeClass('d-none')
          } else {
            $('#another-language-input').addClass('d-none')
          }
        }
      })
    },
  }
</script>
